// MetaField/MetaField.tsx
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Text } from '@nautilusbio/nb-design-system/Text';
import React, { memo, type ReactNode } from 'react';

import styles from './styles.module.css';

export interface MetaFieldProps {
  label: string;
  value?: ReactNode;
  placeholder?: ReactNode;
}

function isEmpty(value: ReactNode): boolean {
  return value === null || value === undefined || value === '';
}

function MetaFieldComponent({ label, value, placeholder }: MetaFieldProps) {
  return (
    <Stack className={styles.field} orientation="vertical">
      <Text as="span" className={styles.label} size="xs">
        {label}
      </Text>
      <Text as="span" size="sm">
        {isEmpty(value) ? placeholder : value}
      </Text>
    </Stack>
  );
}

export const MetaField = memo(MetaFieldComponent);
